import type { CircuitPathResult } from "../../../hooks/useCircuitCablePaths/types";
import type { SplitPathsBySelection } from "./types";

export const splitPathsBySelection: SplitPathsBySelection = ({
  paths,
  selectedId,
}) => {
  if (!selectedId) {
    return { nonSelectedPaths: paths, selectedPaths: [] };
  }

  const nonSelectedPaths: CircuitPathResult[] = [];
  const selectedPaths: CircuitPathResult[] = [];

  for (const path of paths) {
    if (path.destinationId.startsWith(selectedId)) {
      selectedPaths.push(path);
    } else {
      nonSelectedPaths.push(path);
    }
  }

  return { nonSelectedPaths, selectedPaths };
};
